import { render, staticRenderFns } from "./DialogReportUser.vue?vue&type=template&id=8c73ae96&scoped=true"
import script from "./DialogReportUser.vue?vue&type=script&lang=js"
export * from "./DialogReportUser.vue?vue&type=script&lang=js"
import style0 from "./DialogReportUser.vue?vue&type=style&index=0&id=8c73ae96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c73ae96",
  null
  
)

export default component.exports